import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { ArrowRight, ShoppingCartIcon } from "lucide-react";

type ProductListItemProps = {
  name: string;
  subtitle?: string;
  image: string | null | undefined;
  count: number;
  onClick?: () => void;
  sku?: string;
};

export function ProductListItem({
  name,
  subtitle,
  image,
  count,
  onClick,
  sku,
}: ProductListItemProps) {
  const t = useTranslation();

  return (
    <Button
      className="group h-[72px] flex justify-between bg-muted/50 rounded-lg p-4 hover:rounded-[36px] transition-all duration-150 ease-in-out hover:bg-muted items-center w-full"
      onClick={onClick}
    >
      <div className="flex gap-2 items-center text-left overflow-hidden flex-1">
        {image ? (
          <img src={image} className="w-8 h-8 rounded-lg object-cover flex-shrink-0" />
        ) : (
          <div className="w-8 h-8 rounded-lg bg-muted-foreground/20 flex items-center justify-center flex-shrink-0">
            <ShoppingCartIcon className="w-4 h-4 text-muted-foreground/50" />
          </div>
        )}
        <div className="flex flex-col gap-1 overflow-hidden max-w-full">
          <span className="text-sm text-muted-foreground font-semibold flex items-center gap-2 overflow-hidden">
            <span className="truncate max-w-[180px] block">{name}</span>
            {subtitle && <span className="text-xs flex-shrink-0 whitespace-nowrap">{subtitle}</span>}
          </span>
          {sku && (
            <span className="text-xs text-muted-foreground truncate">
              {sku}
            </span>
          )}
          <span className="text-xs text-muted-foreground truncate">
            {t("analyticsDashboard.producstList.articleLabel", {
              articles: count,
            })}
          </span>
        </div>
      </div>
      <ArrowRight className="w-4 h-4 opacity-0 text-muted-foreground group-hover:opacity-100 -translate-x-4 group-hover:translate-x-0 transition-all duration-500 flex-shrink-0 ml-2" />
    </Button>
  );
}
